import React from "react"
import "./index.css"

interface Props {
    label: string
    bookmarked: boolean
    onBookmark: () => void
}

export function Bookmark(props: Props) {
    let {bookmarked, label, onBookmark} = props
    let imgUrl = `/assets/images/icons/v2/${!bookmarked ? "ico-bookmark.svg" : "ico-bookmark-bright.svg"}`

    return (
        <button className="bookmark-btn" onClick={onBookmark}>
            <span className="bookmark-icon">
                <img src={imgUrl} width="14" height="19" alt="bookmark"/>
            </span>
            <span className={`bookmark-label ${bookmarked ? "bookmarked": ""}`}>
                {label}
            </span>
        </button>
    )
}